define('models/calendar/session/exercise/weight/week',[
    'underscore', 'backbone', 'utils',
    // services
    'services/user',
    // collections
    'collections/calendar/session/exercise/weight/sets',
    // models
    'models/calendar/session/exercise/weight/set',
], function(
    _, Backbone, U,
    // services
    User,
    // collections
    CWeightSets,
    // models
    MWeightSet
) {

    var MWeightWeek = Backbone.Model.extend({
        defaults: {
            done: false,
            numSets: 1,
        },

        initialize: function(attrs, options) {

            this.multiEnabled = false;

            if (this.get('numSets') < 1) {
                this.set({ numSets: 1 });
            }

            var sets = this.getSets() || [];
            if (sets.length === 0) {
                sets.push(new MWeightSet());
            }
            if (!sets.models) {
                this.set({ sets: new CWeightSets(sets) });
            }

            this.listenTo(this, "change:numSets", this.onNumSetsChange);

        },

        validate: function(attrs, options) {
            var errors = [];
            if (!this.getSets().isValid(options)) {
                errors.push({ attribute: "sets", error: "There are errors within the sets data." });
                return errors;
            }
        },

        set: function(key, val, options) {

            var attrs;
            if (typeof key === 'object') {
                attrs = key;
                options = val;
            } else {
                (attrs = {})[key] = val;
            }

            // ensure the number of sets is within a reasonable range
            if (_.has(attrs, "numSets") && !_.isUndefined(attrs.numSets)) {
                attrs.numSets = parseInt(attrs.numSets);
                if (_.isNaN(attrs.numSets)) {
                    attrs.numSets = this.get('numSets');
                    this.trigger("change:numSets", this, attrs.numSets, options);
                } else {
                    var numSets = U.between(attrs.numSets, 1, this.constructor.maxSets);
                    if (numSets !== attrs.numSets) {
                        attrs.numSets = numSets;
                        this.trigger("change:numSets", this, numSets, options);
                    }
                }

            }

            // ensure sets field is a collection
            if (_.has(attrs, "sets") && !attrs.sets.models) {
                var sets = attrs.sets;
                if (this.getSets()) {
                    attrs = _.omit(attrs, "sets");
                    this.getSets().reset(sets, options);
                } else {
                    attrs.sets = new CWeightSets(sets);
                }

            }

            return MWeightWeek.__super__.set.call(this, attrs, options);
        },

        getSets: function() {
            return this.get('sets');
        },

        isDone: function() {
            return this.get('done');
        },

        toggleDone: function(value, options) {
            return this.set({
                done: _.isUndefined(value) ? !this.get('done') : Boolean(value)
            }, options);
        },

        toggleMultiReps: function(val, options) {
            this.multiEnabled = val;

            var sets = this.getSets(),
                delta = this.get('numSets') - sets.length;

            if (val && delta > 0) {
                sets.pushSet(delta);
            } else if (val === false) {
                sets.remove(sets.rest(), options);
            }

            this.trigger("change:multiEnabled", this.model, val, options);
        },

        hasMultiRep: function() {
            return this.multiEnabled;
        },

        setLoadUnit: function() {
            this.getSets().each(function(model) {
                if (_.isEmpty(model.get('loadUnit')))
                    model.set('loadUnit', User.getCurrentlySelectedUser().get("weightUnit"));
            });
        },

        copyFirstSetData: function() {
            var firstSet = this.getSets().first();
            _.each(this.getSets().rest(), function(set) {
                set.reset(firstSet.toJSON());
            });
        },

        /////////////
        // actions //
        /////////////
        toJSON: function(options) {
            var copy = MWeightWeek.__super__.toJSON.call(this, options);
            if (_.has(copy, "sets")) {
                copy.sets = copy.sets.toJSON(options);
            }
            return copy;
        },

        ////////////
        // events //
        ////////////
        onNumSetsChange: function(model, value, options) {
            if (this.hasMultiRep()) {
                this.getSets().onNumSetsChange(value);
            }
        },

    }, {
        //////////////////////
        // class properties //
        //////////////////////
        maxSets: 20,
    });

    // Return the model for the module
    return MWeightWeek;
});

